<template>
  <a-modal
    :visible="isShow"
    title="选择附加服务"
    width="800px"
    @ok="submit"
    @cancel="isShow = false"
    ok-text="确认选择"
    cancel-text="取消"
    :z-index="10000"
    :centered="true"
  >
    <div class="service-pc-container">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <a-input-search
          v-model="search"
          placeholder="搜索服务名称..."
          style="width: 100%"
          @search="onSearch"
          enter-button
        />
      </div>

      <!-- 服务列表 -->
      <div class="service-list-pc">
        <a-list item-layout="horizontal" :data-source="filterServiceList">
          <a-list-item slot="renderItem" slot-scope="item, index">
            <a-list-item-meta>
              <div slot="avatar" class="service-avatar">
                <img v-if="item.pic" :src="fileDisplayPrefix + item.pic" />
                <img v-else src="@/assets/服务默认.png" />
              </div>
              <div slot="title" class="service-name-pc">{{ item.name }}</div>
              <div slot="description" class="service-desc-pc">
                <div class="price-tag">￥0.00/{{ getDictName(goodUnitOptions, item.goodUnit) }}</div>
                <div class="intro">{{ item.introduct }}</div>
              </div>
            </a-list-item-meta>
            
            <div class="quantity-control">
              <a-button shape="circle" icon="minus" size="small" @click="subtract(index)" :disabled="item.num <= 0" />
              <span class="quantity-num">{{ item.num || 0 }}</span>
              <a-button shape="circle" icon="plus" size="small" type="primary" @click="add(index)" />
            </div>
          </a-list-item>
        </a-list>
        
        <div v-if="filterServiceList.length === 0" class="empty-box">
          <a-empty description="暂无匹配的服务项目" />
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { FILE_DISPLAY_PREFIX } from '@/api/upload'
import { getDictByType } from '@/api/common'
import { getDictName } from '@/utils/common'
import { queryList } from '@/api/service/service'
import { Modal, Input, List, Button, Empty, Avatar, Icon } from 'ant-design-vue'

export default {
  name: 'ServiceCartPc',
  components: {
    'a-modal': Modal,
    'a-input-search': Input.Search,
    'a-list': List,
    'a-list-item': List.Item,
    'a-list-item-meta': List.Item.Meta,
    'a-button': Button,
    'a-empty': Empty,
    'a-avatar': Avatar,
    'a-icon': Icon
  },
  data() {
    return {
      fileDisplayPrefix: FILE_DISPLAY_PREFIX,
      getDictName,
      isShow: false,
      goodUnitOptions: [],
      queryParams: {},
      search: '',
      serviceList: [],
      filterServiceList: [],
      initList: []
    }
  },
  created() {
    this.refresh()
    getDictByType('good_unit').then(res => {
      if (res.result) {
        this.goodUnitOptions = res.result.map(item => ({
          label: item.dictKey,
          value: item.dictValue
        }))
      }
    })
  },
  watch: {
    search(val) {
      if (val) {
        this.filterServiceList = this.serviceList.filter(i => i.name.toLowerCase().includes(val.toLowerCase()))
      } else {
        this.filterServiceList = this.serviceList
      }
    }
  },
  methods: {
    show(list) {
      this.initData(list)
      this.isShow = true
    },
    initData(list = []) {
      this.initList = list
      const data = {}
      if (Array.isArray(this.initList)) {
        this.initList.forEach(i => data[i.id] = i.num)
      }
      this.serviceList.forEach(s => {
        s.num = data[s.id] || 0
      })
      this.filterServiceList = this.serviceList
      this.$forceUpdate()
    },
    refresh() {
      this.getList()
    },
    getList() {
      this.queryParams.size = -1
      queryList(this.queryParams).then(res => {
        if (res.code === 10000) {
          this.serviceList = res.result.records.map(item => ({
            ...item,
            num: 0
          }))
          this.initData(this.initList)
        }
      })
    },
    onSearch() {},
    add(index) {
      const target = this.filterServiceList[index]
      target.num = (target.num || 0) + 1
      this.$forceUpdate()
    },
    subtract(index) {
      const target = this.filterServiceList[index]
      if (target.num > 0) {
        target.num--
        this.$forceUpdate()
      }
    },
    submit() {
      const selectedData = this.serviceList.filter(i => i.num > 0)
      this.$emit('handleOk', JSON.parse(JSON.stringify(selectedData)))
      this.isShow = false
    }
  }
}
</script>

<style scoped>
.service-pc-container {
  padding: 10px 0;
}
.search-bar {
  margin-bottom: 24px;
}
.service-list-pc {
  max-height: 450px;
  overflow-y: auto;
  padding-right: 10px;
}
.service-avatar img {
  width: 64px;
  height: 64px;
  border-radius: 4px;
  object-fit: cover;
}
.service-name-pc {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.service-desc-pc {
  margin-top: 4px;
}
.price-tag {
  color: #883032;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 4px;
}
.intro {
  font-size: 13px;
  color: #999;
}
.quantity-control {
  display: flex;
  align-items: center;
  gap: 12px;
}
.quantity-num {
  font-size: 16px;
  font-weight: bold;
  width: 30px;
  text-align: center;
}
.empty-box {
  padding: 40px 0;
}
</style>
